import { EVERYTHING, IN_PROGRESS_GOALS } from "../constants/planScopes"
import * as reportPerspectives from "../constants/reportPerspective"
import * as reportSteps from "../constants/reportStep"
import * as steps from "../constants/reportStep"
import { DONE } from "../constants/reportStep"
import { ASSESSMENTS, DEMOGRAPHICS, OUTPUTS_AND_OUTCOMES, PLANS, SUBMITTED_FORMS } from "../constants/reportTypes"
import ReportStep from "../models/pageModels/ReportStep"
import { householdMemberDemographicsReportsEnabled } from "./features"

const householdMemberDemographicsCompletionStep = householdMemberDemographicsReportsEnabled
    ? reportSteps.INCLUDE_HOUSEHOLD_MEMBERS
    : reportSteps.DONE;

const mapping: { [key: string]: { step: string, routeByValues: boolean }} = {
    [PLANS]: { step: reportSteps.PLAN_SCOPE, routeByValues: true },
    [`${PLANS}/${reportSteps.PLAN_SCOPE}[${IN_PROGRESS_GOALS}]`]: { step: reportSteps.DONE, routeByValues: true },
    [`${PLANS}/${reportSteps.PLAN_SCOPE}[${EVERYTHING}]`]: { step: reportSteps.ACTIVE_DATE_RANGE, routeByValues: false },
    [SUBMITTED_FORMS]: { step: reportSteps.FORM_SELECTION, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}`]: { step: reportSteps.REPORT_PERSPECTIVE, routeByValues: true },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ACTIVITY_DATE_RANGE}]`]: { step: reportSteps.ACTIVITY_DATE_RANGE, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]`]: { step: reportSteps.CUSTOM_FILTER, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}`]: { step: reportSteps.AGE_AS_OF_SUMMARY, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}/${reportSteps.AGE_AS_OF_SUMMARY}`]: { step: householdMemberDemographicsCompletionStep, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ACTIVITY_DATE_RANGE}]/${reportSteps.ACTIVITY_DATE_RANGE}`]: { step: householdMemberDemographicsCompletionStep, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}/${reportSteps.AGE_AS_OF_SUMMARY}/${reportSteps.INCLUDE_HOUSEHOLD_MEMBERS}`]: { step: reportSteps.DONE, routeByValues: false },
    [`${SUBMITTED_FORMS}/${reportSteps.FORM_SELECTION}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ACTIVITY_DATE_RANGE}]/${reportSteps.ACTIVITY_DATE_RANGE}/${reportSteps.INCLUDE_HOUSEHOLD_MEMBERS}`]: { step: reportSteps.DONE, routeByValues: false },
    [`${PLANS}/${reportSteps.PLAN_SCOPE}[${EVERYTHING}]/${reportSteps.ACTIVE_DATE_RANGE}`]: { step: reportSteps.DONE, routeByValues: false },
    [DEMOGRAPHICS]: { step: reportSteps.REPORT_PERSPECTIVE, routeByValues: true },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]`]: { step: reportSteps.CUSTOM_FILTER, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}`]: { step: reportSteps.AGE_AS_OF_SUMMARY, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}/${reportSteps.AGE_AS_OF_SUMMARY}`]: { step: householdMemberDemographicsCompletionStep, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ORGANIZATION}]`]: { step: reportSteps.ACTIVE_DATE_RANGE, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ORGANIZATION}]/${reportSteps.ACTIVE_DATE_RANGE}`]: { step: householdMemberDemographicsCompletionStep, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.PROGRAMS}]`]: { step: reportSteps.PROGRAM_NAME, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.PROGRAMS}]/${reportSteps.PROGRAM_NAME}`]: { step: reportSteps.ENROLL_DATE_RANGE, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.PROGRAMS}]/${reportSteps.PROGRAM_NAME}/${reportSteps.ENROLL_DATE_RANGE}`]: { step: householdMemberDemographicsCompletionStep, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.CUSTOM_FILTER}]/${reportSteps.CUSTOM_FILTER}/${reportSteps.AGE_AS_OF_SUMMARY}/${reportSteps.INCLUDE_HOUSEHOLD_MEMBERS}`]: { step: reportSteps.DONE, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.ORGANIZATION}]/${reportSteps.ACTIVE_DATE_RANGE}/${reportSteps.INCLUDE_HOUSEHOLD_MEMBERS}`]: { step: reportSteps.DONE, routeByValues: false },
    [`${DEMOGRAPHICS}/${reportSteps.REPORT_PERSPECTIVE}[${reportPerspectives.PROGRAMS}]/${reportSteps.PROGRAM_NAME}/${reportSteps.ENROLL_DATE_RANGE}/${reportSteps.INCLUDE_HOUSEHOLD_MEMBERS}`]: { step: reportSteps.DONE, routeByValues: false },
    [OUTPUTS_AND_OUTCOMES]: { step: reportSteps.OUTPUTS_AND_OUTCOMES_FORM_SELECTION, routeByValues: false },
    [`${OUTPUTS_AND_OUTCOMES}/${reportSteps.OUTPUTS_AND_OUTCOMES_FORM_SELECTION}`]: { step: reportSteps.ACTIVITY_DATE_RANGE, routeByValues: false },
    [`${OUTPUTS_AND_OUTCOMES}/${reportSteps.OUTPUTS_AND_OUTCOMES_FORM_SELECTION}/${reportSteps.ACTIVITY_DATE_RANGE}`]: { step: reportSteps.DONE, routeByValues: false },
    [ASSESSMENTS]: { step: reportSteps.ASSESSMENT_FORM_SELECTION, routeByValues: false },
    [`${ASSESSMENTS}/${reportSteps.ASSESSMENT_FORM_SELECTION}`]: { step: reportSteps.ACTIVITY_DATE_RANGE, routeByValues: false },
    [`${ASSESSMENTS}/${reportSteps.ASSESSMENT_FORM_SELECTION}/${reportSteps.ACTIVITY_DATE_RANGE}`]: { step: reportSteps.DONE, routeByValues: false }
}

const getNextStep = (locator: string): { step: string, routeByValues: boolean } => {
    return mapping[locator];
} 

const STEP_PARAMETER_MAP: { [key: string]: string[] } = {
    [steps.REPORT_PERSPECTIVE]: ['perspective'],
    [steps.PLAN_SCOPE]: ['scope'],
    [steps.ACTIVE_DATE_RANGE]: ['active_from_date', 'active_to_date'],
    [steps.ACTIVITY_DATE_RANGE]: ['activity_from_date', 'activity_to_date'],
    [steps.ENROLL_DATE_RANGE]: ['enroll_from_date', 'enroll_to_date'],
    [steps.PROGRAM_NAME]: ['program_id', 'program_name'],
    [steps.FORM_SELECTION]: ['form_id', 'version_id', 'form_name'],
    [steps.OUTPUTS_AND_OUTCOMES_FORM_SELECTION]: ['form_id', 'version_id', 'form_name'],
    [steps.ASSESSMENT_FORM_SELECTION]: ['form_id', 'version_id', 'form_name'],
    [steps.AGE_AS_OF_SUMMARY]: ['include_age_summary', 'age_as_of_date'],
    [steps.INCLUDE_HOUSEHOLD_MEMBERS]: ['include_household_members'],
    [steps.CUSTOM_FILTER]: ['custom_query', 'validation']
};

const reconstructSteps = (
    reportType: string, 
    parameters: { [key: string]: string }
): ReportStep[] => {
    const reconstructedSteps: ReportStep[] = [];
    let currentLocator = reportType;

    while (true) {
        const next = getNextStep(currentLocator);

        if (!next || next.step === DONE) {
            break;
        }

        const paramKeys = STEP_PARAMETER_MAP[next.step] || [];
        const values = paramKeys.map(key => ({
            name: key,
            value: parameters[key] || (key === 'validation' ? '[]' : '')
        }));

        reconstructedSteps.push({
            step: next.step,
            values,
            routeByValues: next.routeByValues,
            expanded: false,
            disabled: false,
            validation: []
        });

        const history = reconstructedSteps.map(s => {
            if (s.routeByValues) {
                const vals = s.values.map(v => v.value).join(',');
                return `${s.step}[${vals}]`;
            }
            return s.step;
        }).join('/');

        currentLocator = `${reportType}/${history}`;
    }
    return reconstructedSteps;
};

export { getNextStep, reconstructSteps };
